export const ROLES = {
    admin: "Admin",
    chair: "Chair",
    member: "Member"
}

export const STAGES = {
    to_be_contacted: "To be contacted",
    in_contact: "In contact",
    experience_vistage_event: "Experience Event",
    follow_up: "Follow-up",
    signed_member: "Signed Member",
    lost: "Lost"
}

export const LEAD_STATUS = {
    'qualified': "Qualified",
    'disqualified': "Disqualified",
    'deferred': "Deferred",
    'contact_deleted': "Contact Deleted"
}

export const CONTACT_METHOD = {
    'telephone': "Telephone",
    'email': "Email",
    'meeting': "Meeting"
}

export const DEFERRED = {
    '3_months': "3 months",
    '6_months': "6 months",
    '1_year': "1 year",
    do_not_contact_again: "Do not contact again",
    change_chair: "Change chair"
}
